import { autoserialize } from 'cerialize';

export class Settings {
    @autoserialize pollBeams: boolean;
    public constructor() { }
}
